import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Col, Nav, NavItem, NavLink, Row, TabContent, TabPane,
} from 'reactstrap';

function Tabs({ headers, children }) {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <Row>
      <Col sm="3" className="tabs-responsive-side">
        <Nav className="flex-column nav-pills border-tab nav-left">
          {headers.map((header, index) => (
            <NavItem key={header.content}>
              <NavLink href="#" className={activeTab === index ? 'active' : ''} onClick={() => setActiveTab(index)}>{header.content}</NavLink>
            </NavItem>
          ))}
        </Nav>
      </Col>
      <Col sm="9">
        <TabContent activeTab={activeTab}>
          {children && children.map((child, index) => <TabPane key={`tab-content-${index}`} className="fade show" tabId={index}>{child}</TabPane>)}
        </TabContent>
      </Col>
    </Row>
  );
}

Tabs.propTypes = {
  headers: PropTypes.array.isRequired,
};

export default Tabs;
